import React, { Component } from "react";

import {
  CButton,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle
} from "@coreui/react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";
import { elementToPDF } from "../../../../utils/export";
import Charts from "../../../Charts";
import Loading from "../../../Loading";

import "./styles.scss";

class ComparisonStudentClassroom extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activityId: this.props.activityId,
      groupId: this.props.groupId,
      regionId: this.props.regionId,
      schoolId: this.props.schoolId,
      roomId: this.props.roomId,
      userId: this.props.userId,
      data: null,
      loading: true,
      name: this.props.name
    };
  }

  componentDidMount() {
    this.pullData();
  }

  pullData() {
    const params = {
      group_id: this.state.groupId,
      region_id: this.state.regionId,
      school_id: this.state.schoolId,
      room_id: this.state.roomId,
      user_id: this.state.userId,
      activity_id: this.state.activityId
    };

    axios
      .get(`${URL.api}statistics/evaluation_compare_student_room`, {
        params,
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.setState({ data: resp.data.data });
        this.setState({ loading: false });
      });
  }

  render() {
    if (this.state.loading) {
      return (
        <CModal
          onClose={this.props.onClose}
          show={this.props.show}
          centered
          size="xl w-100 h-100 m-0 p-2 mw-100"
          style={{ width: "80%", height: "80%" }}
          closeOnBackdrop={false}
        >
          <CModalHeader closeButton>
            <CModalTitle>{this.state.name}</CModalTitle>
          </CModalHeader>
          <CModalBody
            className="p-3 d-flex align-items-center justify-content-center"
            style={{ overflow: "auto" }}
          >
            <Loading />
          </CModalBody>
        </CModal>
      );
    }
    return (
      <CModal
        onClose={this.props.onClose}
        show={this.props.show}
        centered
        size="xl w-100 h-100 m-0 p-2 mw-100"
        style={{ width: "100%", height: "100%" }}
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>
          <CModalTitle>{this.state.name}</CModalTitle>
        </CModalHeader>
        <CModalBody className="p-0 d-flex" style={{ overflow: "auto" }}>
          <div className="w-100" id="toPrint">
            <div className="management-1statistics layoutTabelaComparacao flex-column w-100 mb-4">
              <div className="row">
                <div className="chart w-100">
                  <Charts
                    legendY="Nota Média"
                    legendX=""
                    type="bar"
                    title="Comparação de Notas com Estudante"
                    data={{
                      labels: [""],
                      datasets: [
                        {
                          data: [
                            Number(this.state.data.user),
                            Number(this.state.data.max)
                          ],
                          label: "Estudante",
                          backgroundColor: ["rgba(255, 99, 132, 0.2)"],
                          borderColor: ["rgba(255, 99, 132, 1)"],
                          borderWidth: 1
                        },
                        {
                          data: [Number(this.state.data.room)],
                          label: "Turma",
                          backgroundColor: ["rgba(54, 162, 235, 0.2)"],
                          borderColor: ["rgba(54, 162, 235, 1)"],
                          borderWidth: 1
                        },
                        {
                          data: [Number(this.state.data.school)],
                          label: "Escola",
                          backgroundColor: ["rgba(255, 206, 86, 0.2)"],
                          borderColor: ["rgba(255, 206, 86, 1)"],
                          borderWidth: 1
                        },
                        {
                          data: [Number(this.state.data.region)],
                          label: "Regional",
                          backgroundColor: ["rgba(75, 192, 192, 0.2)"],
                          borderColor: ["rgba(75, 192, 192, 1)"],
                          borderWidth: 1
                        },
                        {
                          data: [Number(this.state.data.group)],
                          label: "Grupo",
                          backgroundColor: ["rgba(153, 102, 255, 0.2)"],
                          borderColor: ["rgba(153, 102, 255, 1)"],
                          borderWidth: 1
                        }
                      ]
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </CModalBody>
      </CModal>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ComparisonStudentClassroom);
